import jsPDF from "jspdf";
import { toPng } from "html-to-image";

export const downloadEvidenceMapPDF = () => {
  const fileName = "evidencemaptesting";
  return new Promise((resolve, reject) => {
    try {
      const doc = new jsPDF({
        orientation: "l",
        unit: "mm",
        format: "a3",
      });

      // Retrieve categoriesVisibility from local storage
      const categoriesVisibility = JSON.parse(
        localStorage.getItem("categoriesVisibility")
      );
      if (!categoriesVisibility) {
        console.error("Categories visibility not found in local storage.");
        reject("Categories visibility not found in local storage.");
        return;
      }

      // Reference to the HTML element containing your ReactFlow component (e.g., a div with the id "evidencemap")
      const element = document.getElementById("evidencemap");

      // Check if the element exists
      if (!element) {
        console.error("Element not found.");
        reject("Element not found.");
        return;
      }

      // Create a string to describe the selected categories
      const selectedCategories = Object.keys(categoriesVisibility)
        .filter((category) => categoriesVisibility[category])
        .join(", ");

      // Check if all categories are selected
      const allCategoriesSelected =
        selectedCategories === Object.keys(categoriesVisibility).join(", ");

      let categoriesText = "";
      if (allCategoriesSelected) {
        categoriesText = `Categories Displayed: All categories`;
      } else {
        categoriesText = `Categories Displayed: ${selectedCategories}`;
      }

      // Define the cropping style to remove space from the left side
      const croppingStyle = {
        top: 0,
        left: 10,
        // Adjust the left margin as needed
      };

      // Convert the element to an image using html-to-image with cropping
      toPng(element, { style: croppingStyle })
        .then((imageData) => {
          // Add categories text to the PDF
          doc.text(categoriesText, 10, 10);

          const x = -10;
          const y = 20; // Adjust the vertical position for the image
          const pdfWidth = 420;
          const pdfHeight = 277; // Adjust the height to accommodate the text
          doc.addImage(imageData, "PNG", x, y, pdfWidth, pdfHeight);

          // Save the PDF to a data URL
          const pdfDataUrl = doc.output("datauristring");

          // Create a download link
          const a = document.createElement("a");
          a.href = pdfDataUrl;
          a.download = `${fileName}.pdf`;

          // Simulate a click on the link to trigger the download
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(a.href);
          resolve("Download Complete");
        })
        .catch((error) => {
          console.error("Error converting to image:", error);
          reject("Error converting to image");
        });

      return doc;
    } catch (error) {
      console.error("Error generating PDF:", error);
      reject("Error generating PDF");
    }
  });
};
